<template>
  <div>
    <v-dialog
      v-model="dialog"
      width="90%"
      @click:outside="closeModal"
      :retain-focus="false"
    >
      <farm-geofence-zone
        :popup="true"
        @zone:added="onZoneAdded"
        @closeAddZone="closeModal"
        :farm-id="farmId"
        :location-id="locationId"
      ></farm-geofence-zone>
    </v-dialog>
  </div>
</template>

<script>
import FarmGeofenceZone from "@/views/my_farm/FarmGeofenceZone.vue";
export default {
  components: {
    FarmGeofenceZone,
  },
  computed: {
    dialog() {
      return this.dialogI;
    },
  },
  props: {
    dialogI: {
      type: Boolean,
      required: true,
    },
    farmId: {
      type: Number,
      required: true,
    },
    locationId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    closeModal() {
      this.$emit("newZoneClosed");
    },
    onZoneAdded(zoneName) {
      this.$emit("zone:added", zoneName);
    },
  },
};
</script>
